import { render, staticRenderFns } from "./ResourcePhotoCropper.vue?vue&type=template&id=0dc25a3a&scoped=true&"
import script from "./ResourcePhotoCropper.vue?vue&type=script&lang=ts&"
export * from "./ResourcePhotoCropper.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcePhotoCropper.vue?vue&type=style&index=0&id=0dc25a3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc25a3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc25a3a')) {
      api.createRecord('0dc25a3a', component.options)
    } else {
      api.reload('0dc25a3a', component.options)
    }
    module.hot.accept("./ResourcePhotoCropper.vue?vue&type=template&id=0dc25a3a&scoped=true&", function () {
      api.rerender('0dc25a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/resource-details/ResourcePhotoCropper.vue"
export default component.exports